import ProtectedRoute from "@components/ProtectedRoute";
import React from "react";
import { useIsInclude } from "src/router/RoutersCst";

import Initiative from "@pages/Contents/Corporate/Initiative";
import AddInitiative from "@pages/Contents/Corporate/Initiative/AddInitiative";
import EditInitiative from "@pages/Contents/Corporate/Initiative/EditInitiative";

import EditorialText from "@pages/Contents/Corporate/Initiative/EditorialText";
import AssociationGroup from "@pages/Contents/Corporate/Initiative/AssociationGroup";
import Topics from "@pages/Contents/Corporate/Initiative/Topics";
import EditTopics from "@pages/Contents/Corporate/Initiative/Topics/EditTopics";
import AddTopics from "@pages/Contents/Corporate/Initiative/Topics/AddTopics";
import AssociationTopicCourses from "@pages/Contents/Corporate/Initiative/Topics/AssociationTopicCourses";
import AssociationTopicActivities from "@pages/Contents/Corporate/Initiative/Topics/AssociationTopicActivities";

import Categories from "@pages/Contents/Corporate/Initiative/Categories";
import AddCategory from "@pages/Contents/Corporate/Initiative/Categories/AddCategories";
import EditCategory from "@pages/Contents/Corporate/Initiative/Categories/EditCategories";

import AssociationCategoryCourses from "@pages/Contents/Corporate/Initiative/Categories/AssociationCategoryCourses";
import AssociationCategoryActivities from "@pages/Contents/Corporate/Initiative/Categories/AssociationCategoryActivities";
import AssociationCategoryPaths from "@pages/Contents/Corporate/Initiative/Categories/AssociationCategoryPaths";
import AssociationTopicPaths from "@pages/Contents/Corporate/Initiative/Topics/AssociationTopicPaths";

import Discussion from "@pages/Contents/Corporate/Initiative/Discussion";
import EditDiscussion from "@pages/Contents/Corporate/Initiative/Discussion/EditDiscussion";
import AddDiscussion from "@pages/Contents/Corporate/Initiative/Discussion/AddDiscussion";
import { PagesID } from "@utils/utilsConfigurations";
import InitiativeAssociatedUsers from "@pages/Contents/Corporate/Initiative/UsersInitiative";
import ViewElements from "@pages/Contents/Corporate/Initiative/Categories/ViewElements";
import EditSortingLO from "@pages/Contents/Corporate/Initiative/Categories/ViewElements/EditSortingLO";
import { RouteObject } from "react-router-dom";
import Clusters from "@pages/Contents/Corporate/Initiative/Clusters";
import AddCluster from "@pages/Contents/Corporate/Initiative/Clusters/AddCluster";
import EditCluster from "@pages/Contents/Corporate/Initiative/Clusters/EditCluster";
import AssociationDomain from "@pages/Contents/Corporate/Initiative/Clusters/AssociationDomain";
import AssociationGroupCluster from "@pages/Contents/Corporate/Initiative/Clusters/AssociationGroup";
import Users from "@pages/Contents/Corporate/Initiative/Clusters/Users";
import AssociationLearningObject from "@pages/Contents/Corporate/Initiative/Clusters/AssociationLearningObject";
import LeaderboardClusters from "@pages/Contents/Corporate/Initiative/Leaderboard";
import AddLeaderboardCluster from "@pages/Contents/Corporate/Initiative/Leaderboard/AddCluster";
import EditLeaderboardCluster from "@pages/Contents/Corporate/Initiative/Leaderboard/EditCluster";
import LeaderboardAssociationDomain from "@pages/Contents/Corporate/Initiative/Leaderboard/AssociationDomain";
import LeaderboardAssociationGroupCluster from "@pages/Contents/Corporate/Initiative/Leaderboard/AssociationGroup";
import LeaderboardAssociationLearningObject from "@pages/Contents/Corporate/Initiative/Leaderboard/AssociationLearningObject";
import ScoringCluster from "@pages/Contents/Corporate/Initiative/Leaderboard/Scoring";
import LeaderboardClusterUsers from "@pages/Contents/Corporate/Initiative/Leaderboard/Users";

const useCorporateInitiative: () => RouteObject = () => {
  const { isInclude } = useIsInclude();
  const route: RouteObject = {
    path: "initiative",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&corporate.initiative")}
          >
            <Initiative />
          </ProtectedRoute>
        ),
      },
      {
        path: "add",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&usermgmt.initiatives.create")}
          >
            <AddInitiative />
          </ProtectedRoute>
        ),
      },
      {
        path: "edit/:idInitiative",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&usermgmt.initiatives.update")}
          >
            <EditInitiative />
          </ProtectedRoute>
        ),
      },
      {
        path: ":idInitiative/handle-editorial-text",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&usermgmt.initiatives.write")}
          >
            <EditorialText />
          </ProtectedRoute>
        ),
      },
      {
        path: ":idInitiative/groups-association",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&learning.enrollment.read")}
          >
            <AssociationGroup />
          </ProtectedRoute>
        ),
      },
      {
        path: ":idInitiative/users-associated-list",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&learning.enrollment.read")}
          >
            <InitiativeAssociatedUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: ":idInitiative/categories",
        children: [
          {
            path: "",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.initiatives.categories.read",
                    )}
                  >
                    <Categories />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.initiatives.categories.write",
                    )}
                  >
                    <AddCategory />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idCategory",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.initiatives.categories.write",
                    )}
                  >
                    <EditCategory />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idCategory/association-courses",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.initiatives.categories.read&&learning_catalogue.learning_object.associate.initiatives.categories",
                    )}
                  >
                    <AssociationCategoryCourses />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idCategory/association-activities",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.initiatives.categories.read&&learning_catalogue.learning_object.associate.initiatives.categories",
                    )}
                  >
                    <AssociationCategoryActivities />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idCategory/association-paths",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.initiatives.categories.read&&learning_catalogue.learning_object.associate.initiatives.categories",
                    )}
                  >
                    <AssociationCategoryPaths />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idCategory/view-elements",
                children: [
                  {
                    path: "",
                    index: true,
                    element: (
                      <ProtectedRoute
                        isAllowed={isInclude(
                          "corporate&&usermgmt.initiatives.categories.read&&learning_catalogue.learning_object.associate.initiatives.categories",
                        )}
                      >
                        <ViewElements />
                      </ProtectedRoute>
                    ),
                  },
                  {
                    path: "edit/:idLOSorting",
                    element: (
                      <ProtectedRoute
                        isAllowed={isInclude(
                          "corporate&&usermgmt.initiatives.categories.read&&learning_catalogue.learning_object.associate.initiatives.categories",
                        )}
                      >
                        <EditSortingLO />
                      </ProtectedRoute>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: ":idInitiative/topics",
        children: [
          {
            path: "",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.topics.read")}
                  >
                    <Topics />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.topics.write")}
                  >
                    <AddTopics />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idTopics",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.topics.write")}
                  >
                    <EditTopics />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idTopic/association-courses",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.topics.read&&learning_catalogue.learning_object.associate.topics",
                    )}
                  >
                    <AssociationTopicCourses />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idTopic/association-activities",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.topics.read&&learning_catalogue.learning_object.associate.topics",
                    )}
                  >
                    <AssociationTopicActivities />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":idTopic/association-paths",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.topics.read&&learning_catalogue.learning_object.associate.topics",
                    )}
                  >
                    <AssociationTopicPaths />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
      {
        path: ":initiativeId/community-clusters",
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.read",
                )}
              >
                <Clusters
                  page={PagesID["corporate.initiative.community-cluster"]}
                />
              </ProtectedRoute>
            ),
          },
          {
            path: "add-cluster",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.create",
                )}
              >
                <AddCluster
                  page={PagesID["corporate.initiative.community-cluster.add"]}
                />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit-cluster/:clusterId",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.write",
                )}
              >
                <EditCluster
                  page={PagesID["corporate.initiative.community-cluster.edit"]}
                />
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/cluster-users",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.read",
                )}
              >
                <Users
                  page={PagesID["corporate.initiative.community-cluster.users"]}
                ></Users>
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/domain-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.write",
                )}
              >
                <AssociationDomain
                  page={
                    PagesID[
                      "corporate.initiative.community-cluster.association.initiative"
                    ]
                  }
                ></AssociationDomain>
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/group-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.write",
                )}
              >
                <AssociationGroupCluster></AssociationGroupCluster>
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/learning-object-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.write",
                )}
              >
                <AssociationLearningObject></AssociationLearningObject>
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/discussions",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&corporate.initiative&&cms.wrapper.discussion.read",
                    )}
                  >
                    <Discussion
                      page={PagesID["corporate.initiative.discussion"]}
                    />
                  </ProtectedRoute>
                ),
              },
              {
                index: true,
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&corporate.initiative&&cms.wrapper.discussion.add",
                    )}
                  >
                    <AddDiscussion
                      page={PagesID["corporate.initiative.discussion.add"]}
                    />
                  </ProtectedRoute>
                ),
              },
              {
                index: true,
                path: "edit/:discussionId",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&corporate.initiative&&cms.wrapper.discussion.update",
                    )}
                  >
                    <EditDiscussion
                      page={PagesID["corporate.initiative.discussion.edit"]}
                    />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: ":clusterId",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.community_cluster.update",
                )}
              >
                <Discussion page={PagesID["corporate.initiative.discussion"]} />
              </ProtectedRoute>
            ),
            children: [
              {
                index: true,
                path: "monitor",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.corporates.initiatives.community_cluster.read",
                    )}
                  >
                    <Discussion
                      page={PagesID["corporate.initiative.discussion"]}
                    />
                  </ProtectedRoute>
                ),
              },
              {
                path: "discussion",
                children: [
                  {
                    index: true,
                    path: "",
                    element: (
                      <ProtectedRoute
                        isAllowed={isInclude(
                          "corporate&&corporate.initiative&&cms.wrapper.discussion.read",
                        )}
                      >
                        <Discussion
                          page={PagesID["corporate.initiative.discussion"]}
                        />
                      </ProtectedRoute>
                    ),
                  },
                  {
                    index: true,
                    path: "add",
                    element: (
                      <ProtectedRoute
                        isAllowed={isInclude(
                          "corporate&&corporate.initiative&&cms.wrapper.discussion.add",
                        )}
                      >
                        <AddDiscussion
                          page={PagesID["corporate.initiative.discussion.add"]}
                        />
                      </ProtectedRoute>
                    ),
                  },
                  {
                    index: true,
                    path: "edit/:discussionId",
                    element: (
                      <ProtectedRoute
                        isAllowed={isInclude(
                          "corporate&&corporate.initiative&&cms.wrapper.discussion.update",
                        )}
                      >
                        <EditDiscussion
                          page={PagesID["corporate.initiative.discussion.edit"]}
                        />
                      </ProtectedRoute>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: ":initiativeId/leaderboard-clusters",
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.read",
                )}
              >
                <LeaderboardClusters
                  page={PagesID["corporate.initiative.leaderboard-cluster"]}
                />
              </ProtectedRoute>
            ),
          },
          {
            path: "add-cluster",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.create",
                )}
              >
                <AddLeaderboardCluster
                  page={PagesID["corporate.initiative.leaderboard-cluster.add"]}
                />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit-cluster/:clusterId",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.write",
                )}
              >
                <EditLeaderboardCluster
                  page={
                    PagesID["corporate.initiative.leaderboard-cluster.edit"]
                  }
                />
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/domain-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.write",
                )}
              >
                <LeaderboardAssociationDomain
                  page={
                    PagesID[
                      "corporate.initiative.leaderboard-cluster.association.initiative"
                    ]
                  }
                />
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/group-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.write",
                )}
              >
                <LeaderboardAssociationGroupCluster />
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/learning-object-association",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.write",
                )}
              >
                <LeaderboardAssociationLearningObject />
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/scoring",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.write",
                )}
              >
                <ScoringCluster
                  page={
                    PagesID["corporate.initiative.leaderboard-cluster.scoring"]
                  }
                />
              </ProtectedRoute>
            ),
          },
          {
            path: ":clusterId/ranking",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.corporates.initiatives.leaderboard_cluster.read",
                )}
              >
                <LeaderboardClusterUsers
                  page={
                    PagesID["corporate.initiative.leaderboard-cluster.users"]
                  }
                />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  };
  return route;
};

export default useCorporateInitiative;
